import { useUser } from '@clerk/clerk-react';

export default function Dashboard() {
  const { user } = useUser();

  return (
    <div className="page-enter">
      <h1 className="page-title" style={{ marginBottom: 'var(--space-2)' }}>
        Dashboard
      </h1>
      <p style={{ color: 'var(--color-text-secondary)', fontSize: 'var(--text-sm)' }}>
        Welcome back{user?.firstName ? `, ${user.firstName}` : ''}.
      </p>

      {/* Placeholder cards */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
          gap: 'var(--space-4)',
          marginTop: 'var(--space-8)',
        }}
      >
        {['Companies', 'Projects', 'Orders', 'Fulfillments'].map((label) => (
          <div
            key={label}
            style={{
              background: 'var(--color-surface)',
              border: '1px solid var(--color-border)',
              borderRadius: 'var(--radius-lg)',
              padding: 'var(--space-6)',
              boxShadow: 'var(--shadow-xs)',
            }}
          >
            <p className="label">{label}</p>
            <div
              className="skeleton-line"
              style={{ width: 60, height: 32, marginTop: 'var(--space-3)', borderRadius: 'var(--radius-sm)' }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
